<template>
  <div class="Typeahead">
    <div class="input-group input-group-lg">
      <span class="input-group-addon" id="basic-addon1">
        <span class="glyphicons glyphicons-search"></span>
      </span>
      <input type="text"
             class="Typeahead__input form-control"
             placeholder="Search for Institution"
             autocomplete="off"
             autofocus
             v-model="query"
             @keydown.down="down"
             @keydown.up="up"
             @keydown.enter="hit"
             @keydown.esc="reset"
             @blur="reset"
             @input="update"/>
    </div>
    <ul class="typeahead" v-show="hasItems">
      <li class="typeahead" v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
        <span class="name" v-html="highlightTerm(item.nameOfficial, item.deactive)"></span>
      </li>
    </ul>
  </div>
</template>


<script>
  import DirectoryService from '../endpoints/DirectoryService'
  import { debounce } from 'lodash'
  import OrgAdminService from '../endpoints/admin/OrgAdminService'
  import Notifier from '../common/Notifier'
  import axios from 'axios'

/*  if (!RegExp.escape) {
    RegExp.escape = function (value) {
      return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
    }
  } */

  const escapeRegex = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
  }

  export default {
    data () {
      return {
        query: '',
        items: [],
        current: -1,
        loading: false,
        minChars: 3,
        selected: false
      }
    },
    computed: {
      hasItems () {
        return this.items.length > 0
      }
    },
    created () {
      this.searchDebounced = debounce(this.performSearch, 500)
    },
    beforeUnmount () {
      this.searchDebounced.cancel()
    },
    methods: {
      reset () {
        this.items = []
        this.current = -1
      },
      down () {
        if (this.items.length) this.current = (this.current + 1) % this.items.length
      },
      up () {
        if (this.items.length) this.current = (this.current + this.items.length - 1) % this.items.length
      },
      hit () {
        if (this.items[this.current]) this.onHit(this.items[this.current])
      },
      setActive (index) {
        this.current = index
      },
      activeClass (index) {
        return { active: index === this.current }
      },
      onHit (data) {
        this.selected = true
        this.query = data.nameOfficial
        this.items = []
        if (data.deactive === 'Y') {
          window.location.href = OrgAdminService.getMobyAdminEndPoint(data.orgId)
        } else {
          window.location.href = DirectoryService.getOrgDetailEndPoint() + '?id=' + data.orgId
        }
      },
      highlightTerm (data, deactive) {
        let regex = new RegExp('(' + escapeRegex(this.query) + ')', 'ig')
        data = data.replace(regex, '<span class="highlight">$1</span>')
        return data + (deactive === 'Y' ? ' (Deactivated)' : '')
      },
      update () {
        this.searchDebounced()
      },
      performSearch () {
        let _this = this

        if (!this.query) {
          return this.reset()
        }

        if (this.selected) {
          this.selected = false
          return
        }

        if (this.minChars && this.query.length < this.minChars) {
          return
        }

        this.loading = true

        const query = this.query
        axios.get(DirectoryService.getOrgSearchEndPoint(), { params: { q: query } }).then(function (response) {
          if (_this.query === query) {
            _this.items = response.data
            _this.current = -1
          }
        }).catch(error => {
          Notifier.error(error.message)
        }).finally(() => {
          _this.loading = false
        })
      }
    }
  }
</script>


<style scoped>

  ul.typeahead {
    position: absolute;
    padding: 0;
    margin-top: 8px;
    min-width: 100%;
    background-color: #fff;
    list-style: none;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    z-index: 1000;
  }

  li.typeahead {
    padding: 5px 20px;
    border-bottom: none;
    cursor: pointer;
    min-width: 100%;
  }

  li.typeahead:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  li.typeahead:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 0;
  }

  :deep(span.highlight) {
    display: inline;
    font-weight: bold;
  }

  .active {
    background-color: #428bca;
  }

  .active span {
    color: white;
  }

  .name {
    font-weight: normal;
    font-size: 14px;
  }
</style>
